import React from 'react'
import TemplateForm from './TemplateForm'

/**
 * The old Upload Template address (/upload-template): the Create Template
 * form, started on "Upload an HTML file" for an email. Nothing links here any
 * more (Create Template offers the same choice, one entry instead of two);
 * the route stays so bookmarks and old links still open the right form.
 *
 * It used to be a page of its own posting to POST
 * /comms/template/upload_template, which created an inactive email with only
 * a subject and an approver (no sender, reply-to, calendar invite,
 * attachments, variables or comment), skipped the name-taken check, and took
 * only .tmpl files, so an email downloaded from the library (.html) could not
 * go back in. The form creates through POST /comms/v2/template with every
 * email field, takes .html, .htm and .tmpl, and names the template after the
 * file until a name is typed, as the old upload did.
 */
const UploadTemplate = () => <TemplateForm uploadHtml />

export default UploadTemplate
